import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LOCALES, STRINGS } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "vivasvan.lang";

const detect = () => {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && STRINGS[stored]) return stored;
  // Default to EN for institutional consistency; users opt-in to FR/PT via the switcher.
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => detect());

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
      document.documentElement.lang = locale;
    } catch {
      /* ignore */
    }
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      t: STRINGS[locale] || STRINGS.en,
      locales: LOCALES,
    }),
    [locale]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
